import React from 'react';
import { motion } from 'framer-motion';
interface SectionDividerProps {
  quote: string;
}
export function SectionDivider({
  quote
}: SectionDividerProps) {
  return <div className="w-full py-12 flex flex-col items-center justify-center px-4" data-id="element-261">
      <div className="flex items-center justify-center w-full max-w-xs mb-6 opacity-30" data-id="element-262">
        <div className="h-px bg-brand-plum flex-1" data-id="element-263"></div>
        <span className="mx-4 text-brand-gold text-2xl" data-id="element-264">✧</span>
        <div className="h-px bg-brand-plum flex-1" data-id="element-265"></div>
      </div>
      <motion.p initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="font-script text-2xl md:text-3xl text-brand-plum text-center max-w-2xl" data-id="element-266">
        "{quote}"
      </motion.p>
    </div>;
}